import { render } from "./ProfilePage-View.vue?vue&type=template&id=5630a076"
import script from "./ProfilePage-View.vue?vue&type=script&lang=js"
export * from "./ProfilePage-View.vue?vue&type=script&lang=js"

import "./ProfilePage-View.vue?vue&type=style&index=0&id=5630a076&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__